import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './DJTVSearch.css';

function DJTVSearch({ tableData }) {
    return (
        <div className="DJTV_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para DJTV</h4>
            )}
        </div>
    );
}

export default DJTVSearch;
